module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_review-9074066f3f9de778e64d15e06405bc35.svg";